<template>
  <div id="newsDetail">
    <div class="head">
      <H3>{{newsDetail.title}}</H3>
    </div>
    <div class="content" v-html="newsDetail.content"></div>
  </div>
</template>

<script>
  import newsData from '../../static/newsData'

  export default {
    name: 'newsDetail',
    data() {
      return {
        newsData,
        id: this.$route.query.id
      }
    },
    components: {},
    created() {
    },
    computed: {
      newsDetail(){
        let data = null
        for (let k in this.newsData){
          this.newsData[k].forEach(item => {
            if (this.id === item.id){
              data = item
            }
          })
        }
        return data
      }
    },
    methods: {}
  }
</script>

<style lang="less">
  #newsDetail {
    .head{
      height: 90px;
      border-bottom: 1px solid #dedede;
      h3{
        font-size: 24px;
        font-weight: bold;
        line-height: 90px;
        padding-left: 20px;
        color: #5E5E5E;
      }
    }
    .content{
      padding: 50px;
      .img_wrapper{
        width: 400px;
        float: left;
        img{
          width: 100%;
        }
      }
      p{
        font-size: 16px;
        padding-left: 450px;
        margin-bottom: 30px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/newsDetail.vue